import _ from "lodash";
import { DATA_GRID_COLUMN_TYPES } from "../constants";

export const addErrorForGrade = ({ errors, studentId, gradeId, columnId }) => {
  const currentStudentErrors = errors.get(studentId) || new Map();
  errors.set(studentId, currentStudentErrors);

  const gradeErrors = currentStudentErrors.get(gradeId) || new Set();
  gradeErrors.add(columnId);
  currentStudentErrors.set(gradeId, gradeErrors);
};

export const checkForErrors = ({ studentWiseData }) => {
  const errors = new Map();

  _.forEach(studentWiseData, (grades, studentId) => {
    _.forEach(grades, currentGrade => {
      const { grade, school, academicYear, gradingPeriods } = currentGrade;
      const gradeId = _.get(grade, "id");

      if (_.isNil(school)) {
        addErrorForGrade({
          errors,
          studentId,
          gradeId,
          columnId: DATA_GRID_COLUMN_TYPES.ASSOCIATED_SCHOOL,
        });
      }

      if (_.isNil(academicYear)) {
        addErrorForGrade({
          errors,
          studentId,
          gradeId,
          columnId: DATA_GRID_COLUMN_TYPES.ACADEMIC_YEARS,
        });
      }

      if (_.isEmpty(gradingPeriods)) {
        addErrorForGrade({
          errors,
          studentId,
          gradeId,
          columnId: DATA_GRID_COLUMN_TYPES.GRADING_PERIODS,
        });
      }
    });
  });

  return errors;
};

export const hasError = ({ isEditMode, errors, gradeId, columnId }) =>
  isEditMode && errors.get(gradeId)?.has(columnId);
